import AIEmailTemplateTypeSelect from '@/components/selects/AIEmailTemplateTypeSelect';
import { useUnlayerTemplatesEditorContext } from '@/components/views/UnlayerEmailsView/UnlayerTemplatesShared/UnlayerTemplatesEditorView/UnlayerTemplatesEditorContext';
import { FormControl, FormLabel } from '@mui/material';
import React from 'react';

const AiTemplateType = () => {
	const {
		templateForm,
		patchTemplateValues,
		isFetchingTemplateDetail,
		isCreatingTemplate,
		isUpdatingTemplate,
		isDeletingTemplate,
		isSharingTemplate = false,
		canModifySelectedTemplate = true,
	} = useUnlayerTemplatesEditorContext();
	const { values } = templateForm;

	const templateValue = values.workflowType || 'None';

	const isSaving =
		isCreatingTemplate || isUpdatingTemplate || isDeletingTemplate || isSharingTemplate;

	const disabled = isFetchingTemplateDetail || isSaving || !canModifySelectedTemplate;

	return (
		<FormControl fullWidth>
			<FormLabel htmlFor='workflowType'>Template type</FormLabel>
			<AIEmailTemplateTypeSelect
				id='workflowType'
				value={templateValue}
				setValue={(workflowType) => patchTemplateValues({ workflowType })}
				disabled={disabled}
			/>
		</FormControl>
	);
};
export default AiTemplateType;
